import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d03ebed8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wms-client" }
const _hoisted_2 = { class: "wms-client__title-wrap" }
const _hoisted_3 = { class: "wms-client__title" }
const _hoisted_4 = { class: "wms-client__content" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card__title" }, "CWMS中心仓", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__btn__text" }, "打开客户端", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__btn__text" }, "打开网页端", -1))
const _hoisted_9 = { class: "card" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card__title" }, "IWMS基地仓", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__btn__text" }, "打开网页端", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_close_bold = _resolveComponent("close-bold")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_image, {
      class: "wms-client__header-bg",
      style: {},
      src: `${_ctx.FILESERVICE}/file/4pl/webclient/img/wms-introduct-title-bg.png`,
      fit: "fill"
    }, null, 8, ["src"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(" 页面跳转 "),
        _createVNode(_component_close_bold, {
          class: "wms-client__title__icon",
          onClick: _ctx.onClose
        }, null, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", {
          class: "card__btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toWMSClient(true)))
        }, [
          _createVNode(_component_SvgIcon, {
            name: "app-client",
            size: "30 30"
          }),
          _hoisted_7
        ]),
        _createElementVNode("div", {
          class: "card__btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toWMSClient(false)))
        }, [
          _createVNode(_component_SvgIcon, {
            name: "web-client",
            size: "30 30"
          }),
          _hoisted_8
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", {
          class: "card__btn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toIWMSClient()))
        }, [
          _createVNode(_component_SvgIcon, {
            name: "web-client",
            size: "30 30"
          }),
          _hoisted_11
        ])
      ])
    ])
  ]))
}